<template>
    <FormStep :title="appSettings.ElNetworkModuleStep4.Title" :stepNumber=4  @toggleBody="onFormStepBodyToggle">
        <div class="electrictiy-bill-calculator__form-intro-container">
            <div class="electrictiy-bill-calculator__form-preamble" v-if="appSettings.ElNetworkModuleStep4.Ingress" v-html="appSettings.ElNetworkModuleStep4.Ingress">
            </div>
        
            <read-more v-if="appSettings.ElNetworkModuleStep4.ReadMoreText" :button-text="appSettings.ElNetworkModuleStep4.ReadMoreButtonText" element-id="read-more-step-1">
                <p v-html="appSettings.ElNetworkModuleStep4.ReadMoreText">
                </p>
            </read-more>
        </div>       
                
        <div class="electrictiy-bill-calculator__range-inputs-container" v-if="showRangeInputs">                
            <div v-for="i in 12" :key="i" class="electrictiy-bill-calculator__range-month-input-container">
                <div class="electrictiy-bill-calculator__range-month">
                    <label :for="'powerPeak-'+i">{{util.getMonthName(i, false)}}</label>
                </div>
                <div class="electrictiy-bill-calculator__range-input-container">
                    <input :id="'powerPeak-'+i" type="range" :min="rangeMin" :max="rangeMax" step="0.01" v-model="monthlyPowerPeak[i]" @input="setNumberBoxPosition(i)">
                    <span class="electrictiy-bill-calculator__range-input-high-text">Antal {{rangeUnit}}</span>
                    <div class="electrictiy-bill-calculator__range-input-number" :ref="el => setItemRef(el, i)">{{ util.getFormatedValue( monthlyPowerPeak[i], 2, rangeUnit)}}</div>
                </div>
            </div>
        </div>
    </FormStep>
</template>


<script setup>
    import FormStep from './FormStep.vue';
    import ReadMore from './ReadMore.vue';
    import util from '../util'
    import { useWizardStore } from '../stores/WizardStore';
    import { storeToRefs } from "pinia";
    
    import { computed, watch, ref, nextTick, onMounted} from 'vue'

    const store = useWizardStore()
    const {appSettings, monthlyPowerPeak, yearlyConsumption } = storeToRefs(store);
    
    const rangeUnit = 'kW';
    const showRangeInputs = ref(true);
    let itemRefs = [];

    const rangeMin = computed(() => {
        let monthlyEffectChargeData = store.monthlyEffectChargeDataForSelectedFuse;
        return monthlyEffectChargeData ? monthlyEffectChargeData.MinValue : 0;
    })
    const rangeMax = computed(() => {
        let monthlyEffectChargeData = store.monthlyEffectChargeDataForSelectedFuse;
        return monthlyEffectChargeData ? monthlyEffectChargeData.MaxValue : 1000;
    })    

    const setNumberBoxPosition = (i) => {        
        let min = rangeMin.value;
        let max = rangeMax.value;

        //Size of the range thumb
        const thumbSize = 14;

        const leftPercent = Math.min(monthlyPowerPeak.value[i]/((min +max))*100, 100);
        let leftPercentPxFix = 0;
        if(leftPercent >= 50) {
            const leftPercentDiff = leftPercent - 50;
            leftPercentPxFix = (leftPercentDiff/100) * -(thumbSize);
        } else {
            const leftPercentDiff = 50 - leftPercent;
            leftPercentPxFix = (leftPercentDiff/100) * (thumbSize);
        }
        itemRefs[i-1].style.left = 'calc(' +leftPercent +'% + ' + leftPercentPxFix +'px)';
    }
    
    const setItemRef = (el, index) => {
        if (el) {                
            if(itemRefs.length >= index) {
                itemRefs[index-1] = el;
            } else {
                itemRefs.push(el)
            }
        }
    };

    const updateNumberBoxes = () => {
        itemRefs.forEach((itemRef, index) => {
            setNumberBoxPosition(index+1);
        });
    }

    const updateMonthlyPowerPeakBasedOnYearlyConsumption = () => {
        store.updateMonthlyPowerPeakBasedOnYearlyConsumption();
    }    

    watch(yearlyConsumption, (newVal, oldVal) => {
        if(newVal != oldVal) {
            updateMonthlyPowerPeakBasedOnYearlyConsumption();
        }
    })

    //Update number boxes when calculated price is updated in the state
    watch(monthlyPowerPeak, () => {    
        updateNumberBoxes();
     }, {deep: true})        


     const onFormStepBodyToggle = (isOpen) => {
        showRangeInputs.value = isOpen;
        if(isOpen) {
            nextTick(() => {
                updateNumberBoxes();
            });
        }
    }     
    onMounted(() => {  
        updateMonthlyPowerPeakBasedOnYearlyConsumption();        
    })   

</script>

<style scoped>

</style>
